package org.hs_soft.runmynesto.domain.config.language

object EnglishStrings : StringResources {
    override val given="Given"
    override val receiptNo = "Receipt No."
    override val receiptsList = "Receipts list"
    override val dragColumnHint="Drag a column heading here to group it by this column"
    override val selectCashRegisters="Select cash registers"
    override val priceCategory = "Price category"
    override val fixedProducts = "Fixed Products"
    override val gang="Course"
    override val addNewSelection="Add New Selection"
    override val quantity = "Quantity"
    override val fixedQuantity = "Fixed Quantity"
    override val maxQuantity = "Max Quantity"
    override val minQuantity = "Min Quantity"
    override val isTheMenuName = "Is the menu name"
    override val selection = "Selection"
    override val addNewPrice="Add new price"
    override val endTime="End Time"
    override val individualPrice="Individual Price"
    override val numberOfButtons="Number of buttons"
    override val sorting = "Sorting"
    override val sortingAutoByName = "Sorted by name"
    override val sortingAutoByNumber = "Sorted by number"
    override val sortingManual = "Manual"
    override val doYouWantToRemove="Do you want to remove"
    override val error = "Error"
    override val singleRightDoor: String = "Single right door"
    override val singleLeftDoor: String = "Single left door"
    override val multiFactorAuthentication="Multi-Factor Authentication"
    override val signIn="Sign In"
    override val enterLoginRequiredData="Please enter the required data to log in to the system."
    override val verificationInfo="Your account is secured using Multi-Factor Authentication (MFA). Please enter the following authentication code to complete the sign-in"
    override val noData="No Data"
    override val shopName="Shop name"
    override val edit="Edit"
    override val price3="Price 3"
    override val altName="Alternative article name"
    override val salesUnit="Sales unit"
    override val presetRoom="Preset room"
    override val priceShowOnKitchenReceipt="Show price on kitchen receipt"
    override val printDishesOfTheNextCourse="Print dishes of the next course"
    override val store="Store"
    override val poiId = "POI ID"
    override val liveEndpointUrlPrefix = "Live Endpoint URL Prefix"
    override val apiKey = "API Key"
    override val applicationKey = "Application Key"
    override val roomId = "Room ID"
    override val virtualTerminalId = "Virtual Terminal ID"
    override val terminalId = "Terminal ID"
    override val userId = "User ID"
    override val posID="POS ID"
    override val tId: String="TID"
    override val hardware="Hardware"
    override val creditCardLink="Credit card link"
    override val openCashDrawerAfterEFTTransaction="Open cash drawer after EFT transaction"
    override val tcpIP="TCP/IP"
    override val terminal="Terminal"
    override val tse="TSE"
    override val eftTerminal="EFT Terminal"
    override val activate="Activate"
    override val adminPin="Admin PIN"
    override val adminPUK="Admin PUK"
    override val tseType="TSE Type"
    override val printQRCode="Print QR-Code"
    override val timeadminPin="Timeadmin PIN"
    override val timeadminPUK="Timeadmin PUK"
    override val tseLocation="TSE Location"
    override val tseInformation="TSE Information"
    override val activeKitchenPrinter="Active kitchen printer"
    override val printReceiptAfterCompletion="Print receipt after completion"
    override val printKitchenOnlyForTables="Print kitchen only for tables"
    override val kitchenLocations="Kitchen locations"
    override val topEdgeCm="Top edge (cm)"
    override val separateCakeToppings="Separate cake toppings"
    override val tableShift="Table shift"
    override val uploadImgInfoSize="256x256 px"
    override val apaleoPMSSubAccounts="Apaleo PMS sub accounts"
    override val uploadImgInfoType="JPG, PNG"
    override val uploadManually="Upload manually"
    override val generateUsingAI="Generate using AI"
    override val updatingApaleoPaymentWithCashRegister="Updating the Apaleo payment methods with the cash register payment methods"
    override val selectSalesGroupsForApaleoSubaccounts="Select sales groups for apaleo subaccounts"
    override val clientId="Client ID"
    override val clientSecret="Client Secret"
    override val export="Export"
    override val noValidIPAddress="No valid IP address"
    override val apaleoPMSProperty="Apaleo PMS property"
    override val port="Port"
    override val pmsType="PMS-Type"
    override val printReceiptAutomatically="Print receipt automatically"
    override val transferAllDocuments="Transfer of all documents"
    override val pms="PMS"
    override val createCard="Create card"
    override val loading: String="Loading..."
    override val selected: String = "Selected"
    override val category: String = "Category"
    override val turnoverGroup: String = "Turnover Group"
    override val ingredients: String = "Ingredients"
    override val productNumber: String = "Product Number"
    override val alcoholic: String = "Alcoholic"
    override val vegan: String = "Vegan"
    override val vegetarian: String = "Vegetarian"
    override val disable: String = "Disabled"
    override val protel: String = "Protel"
    override val apaleo: String = "Apaleo"
    
    // Table types
    override val squaredTable: String = "Square Table"
    override val roundTable: String = "Round Table"
    
    // Element actions
    override val addElement: String = "Add Element"
    override val editElement: String = "Edit Element"
    
    // Interior design elements
    override val structure: String = "Structure"
    override val furniture: String = "Furniture"
    override val interiorDecoration: String = "Interior Decoration"
    override val indicators: String = "Indicators"
    
    // Structure elements
    override val horizontalWall: String = "Horizontal Wall"
    override val verticalWall: String = "Vertical Wall"
    override val horizontalWindow: String = "Horizontal Window"
    override val verticalWindow: String = "Vertical Window"
    override val squaredColumn: String = "Square Column"
    override val roundedColumn: String = "Round Column"
    override val singleDoor: String = "Single Door"
    override val doubleDoors: String = "Double Doors"
    
    // Furniture elements
    override val chair: String = "Chair"
    override val barStool: String = "Bar Stool"
    override val armChair: String = "Armchair"
    override val twoSeaterSofa: String = "Two-Seater Sofa"
    override val threeSeaterSofa: String = "Three-Seater Sofa"
    override val cocktailBarTable: String = "Cocktail/Bar Table"
    
    // Interior decoration elements
    override val tree: String = "Tree"
    override val bush: String = "Bush"
    override val plant: String = "Plant"
    
    // Indicator elements
    override val exit: String = "Exit"
    override val wc: String = "WC"
    
    // Form inputs
    override val enterCompanyName: String = "Enter company name"
    override val country: String = "Country"
    override val kitchenStations: String = "Kitchen Stations"
    override val writeNewRoomNameToAdd: String = "Write new room name to add"
    
    override val lookingForAnswer="Looking for an answer..."
    override val tel="Tel"
    override val shopsExclusiveTemplate="Shops exclusive template"
    override val position="Position"
    override val comparedToPreviousWeek="Compared to last weeks revenues, same day"
    override val printerLocations="Printer locations"
    override val setDefaultValuesForNewCustomer: String="Set default values for new customer"
    override val paymentMethods="Payment Methods"
    override val save="Save"
    override val disableContentOnDevice="Disabling content on the device"
    override val transferSettingFromCashRegister: String="Transfer settings from cash register"
    override val androidSerialNumber="Android serial number"
    override val cashRegisterType="Cash register type"
    override val addNewBusinessOfficeDE="Add new business office"
    override val addNewRegionDE= "Add new region"
    override val addNewBranchDE= "Add new branch"
    override val addNewCashRegisterDE="Add new cash register"
    override val addNewDevice="Add new device"
    override val vatNormal = "VAT normal"
    override val vatReduced = "VAT reduced"
    override val vatFree = "No VAT"
    override val vatSpecial = "VAT special"
    override val delete: String = "Delete"
    override val copy: String = "Copy"
    override val tableNumber: String = "Table Number"
    override val enterTableNumber: String = "Enter table number"
    override val seats: String = "Seats"
    override val restoMate: String = "RestoMate"
    override val restoMateDescription: String = "Your AI-powered restaurant companion"
    override val dataAssistantDatabaseLoadingTitle: String = "Your database is loading..."
    override val dataLoadingProgressCategoryImportTitle: String = "Categories are uploading..."
    override val dataLoadingProgressMenuCardImportTitle: String = "Your Menu Card is uploaded"
    override val editFloor: String = "Edit floor"
    override val list: String = "List"
    override val tiles: String = "Tiles"
    override val desktopWaiter: String = "DesktopWaiter"
    override val mobileWaiter: String = "MobileWaiter"
    override val listingLayout: String = "Listing Layout"
    override val device: String = "Device"
    override val cash: String = "Cash"
    override val eft: String = "EFT"
    override val tips: String = "Tips"
    override val revenueGuest: String = "Revenue/Guest"
    override val totalRevenue: String = "Total revenue"
    override val analizeQuestionProcess: String = "Analyzing question..."
    override val generateSQLProcess: String = "Generating SQL..."
    override val formatAnswerProcess: String = "Formatting SQL..."
    override val createFilesProcess: String = "Creating files..."
    override val uploadFilesProcess: String = "Uploading files..."
    override val generateMenuCardProcess: String = "Generating menu card..."
    override val clearMenuCardProcess: String = "Clearing menu card..."
    override val prepareResultProcess: String = "Preparing result..."
    override val menuCardProgressMessage: String = "steps are done"
    override val menuCardSelectFilesMessages: String = "Choose files(.pdf, .png, .jpg) not bigger than 3MB"
    override val filesChosen: String = "file(s) chosen"
    override val uploaded: String = "uploaded"
    override val generalInfo: String = "General Info"
    override val download: String = "Download"
    override val doYouWantToRemoveThisFloor: String = "Do you want to remove this floor?"
    override val doYouWantToRemoveThisRoom: String = "Do you want to remove this room?"
    override val newRoomName: String = "New room name"
    override val floorNumber: String = "Floor number"
    override val addNewFloor: String = "Add new floor"
    override val wall: String = "Wall"
    override val floor: String = "Floor"
    override val show3D: String = "Show 3D"
    override val addFloor: String = "Add Floor"
    override val interiorDecor: String = "Interior Decor"
    override val add: String = "Add"
    override val table: String = "Table"
    override val roomName: String = "Room Name"
    override val projectName: String = "Project Name"
    override val restaurantManager: String = "Restaurant Manager"
    override val addNewGroup: String = "Add new group"
    override val editGroup: String = "Edit Group"
    override val shopaffiliation: String = "Shop affiliation"
    override val dateInterval: String = "dateInterval"
    override val selfCheckout_1080_1920: String = "SelfCheckout (1024*600)"
    override val standard_1024_600: String = "Standard (1024*600)"
    override val addNewMedia: String = "Add new media"
    override val refreshTime: String = "Refresh time"
    override val chooseAnArticle: String = "Choose an Article"
    override val advertisingDuringTyping: String = "Advertising during typing"
    override val fullDisplayAdvertising: String = "Full Display Advertising"
    override val stayActive: String = "Stay Active"
    override val media: String = "Media"
    override val mediaCenter: String = "Media Center"
    override val actions: String = "Actions"
    override val disableCompletion: String = "Disable completion"
    override val reason: String = "Reason"
    override val deactivateDailyClosing: String = "Deactivate daily closing"
    override val group: String = "Group"
    override val groupByDateShop: String = "Group by Date/Shop"
    override val groupByShop: String = "Group by Shop"
    override val groupByDate: String = "Group by Date"
    override val inTotal: String = "In Total"
    override val printFinancialStatements: String = "Print financial statements"
    override val selectedItem: String = "Selected Item"
    override val exportExcel: String = "Excel"
    override val price: String = "Price"
    override val percentSign: String = "%"
    override val code: String = "Code"
    override val productDateShop: String = "Product-Date-Shop"
    override val productDate: String = "Product-Date"
    override val dateProduct: String = "Date-Product"
    override val productShop: String = "Product-Shop"
    override val shopProduct: String = "Shop-Product"
    override val lastSale: String = "Last Sale"
    override val weight: String = "Weight"
    override val firstSale: String = "First Sale"
    override val groupedBy: String = "Grouped by"
    override val notCancelled: String = "Not Cancelled"
    override val cancelled: String = "Cancelled"
    override val userName: String = "User name"
    override val total: String = "Total"
    override val cancellation: String = "Cancellation"
    override val pdf: String = "PDF"
    override val billNumberFrom: String = "From Receipt No,"
    override val BillNumberTo: String = "To Receipt No,"
    override val totalTo: String = "To Total"
    override val totalFrom: String = "From Total"
    override val abcStatistic: String = "ABC Statistic"
    override val billSearch: String = "Bill Search"
    override val setting: String = "Setting"
    override val statistic: String = "Statistic"
    override val threeWeeksAgo: String = "3 weeks ago"
    override val twoWeeksAgo: String = "2 weeks ago"
    override val lastWeek: String = "Last week"
    override val compare: String = "Compare"
    override val sales: String = "Sales"
    override val allTheRegions: String = "All the regions"
    override val clients: String = "Clients"
    override val workingHours: String = "Working hours"
    override val hourlyRate: String = "Hourly rate"
    override val averageCheck: String = "Average check"
    override val turnOver: String = "Turnover"
    override val euro: String = "€"
    override val cashRegisters: String = "Cash Registers"
    override val restaurantsOf: String ="Restaurants of"
    override val dashboard: String = "Dashboard"
    override val backgroundColor: String = "Background Color"
    override val fakeLatestPurchasesAndMore: String = "https://shortlink.com/**********"
    override val fakeQRCode: String = "0000-0000-0000-0000"
    override val fakeCustomerNumber: String = "0000001"
    override val incomeAndExpanse: String = "Income $ Expanses"
    override val cashBookAndCoupons: String = "CashBook $ Coupons"
    override val credit: String = "Credit"
    override val pressets: String = "Pressets"
    override val apply: String = "Apply"
    override val amountCHF: String = "Amount CHF"
    override val amount: String = "Amount"
    override val difference: String = "Difference"
    override val cashDelivery: String = "Cash Delivery"
    override val IsnInCHF: String = "Isn in CHF"
    override val course: String = "Course"
    override val lst: String = "lst"
    override val currency: String = "Currency"
    override val reduction: String = "Reduction"
    override val freeVat: String = "Free Vat"
    override val empty: String = "Empty"
    override val reports: String = "Reports"
    override val FROM_DATE: String = "From Date"
    override val GROUP: String = "group"
    override val BALANCE: String = "balance"
    override val BOOKING_MODE: String = "booking mode"
    override val UNTIL_DATE: String = "Until Date"
    override val CHECKOUT: String = "Checkout"
    override val CREDIT: String = "Credit"
    override val POINTS: String = "points"
    override val CHECKOUT_DATE: String = "checkout date"
    override val DESIGNATION: String = "Designation"
    override val DOCUMENT_NUMBER: String = "document number"
    override val BURDEN: String = "Burden"
    override val POINTS_BALANCE: String = "points balance"
    override val CASH_REGISTER_TIME: String = "cash register time"
    override val cashRegisterName: String = "Cash Register Name"
    override val selectDesiredColumns: String = "Select the desired columns"
    override val transaction: String = "Transactions"
    override val addNewCustomerCard: String = "Add new customer card"
    override val digitalCustomerCard: String = "Digital Customer Card"
    override val rfidCustomerCard: String = "RFID Customer Card"
    override val zeroSetting: String = "No Setting"
    override val none: String = "None"
    override val discountGroup1: String = "Discount Group 1"
    override val discountGroup2: String = "Discount Group 2"
    override val discountGroup3: String = "Discount Group 3"
    override val discountGroup4: String = "Discount Group 4"
    override val discountGroup5: String = "Discount Group 5"
    override val discountGroup6: String = "Discount Group 6"
    override val discountGroup7: String = "Discount Group 7"
    override val discountGroup8: String = "Discount Group 8"
    override val discountGroup9: String = "Discount Group 9"
    override val discountGroup10: String = "Discount Group 10"
    override val discountGroup11: String = "Discount Group 11"
    override val discountGroup12: String = "Discount Group 12"
    override val discountGroup13: String = "Discount Group 13"
    override val discountGroup14: String = "Discount Group 14"
    override val discountGroup15: String = "Discount Group 15"
    override val discountGroup16: String = "Discount Group 16"
    override val discountGroup17: String = "Discount Group 17"
    override val discountGroup18: String = "Discount Group 18"
    override val discountGroup19: String = "Discount Group 19"
    override val discountGroup20: String = "Discount Group 20"
    override val inHouseCard: String = "In House Card"
    override val loyaltyCard: String = "Loyalty Card"
    override val clientName: String = "Client Name"
    override val salutation: String = "Salutation"
    override val resetBooking: String = "Reset Booking"
    override val cardHolder: String = "Card Holder"
    override val loadLabels: String = "Load Labels"
    override val loadMaps: String = "Load Maps"
    override val loadingLabeling: String = "Loading/Labeling"
    override val labelingWorkCards: String = "Labeling Work Cards"
    override val loadingWorkCards: String = "Loading Work Cards"
    override val createCustomerCard: String = "Create Customer Card"
    override val until: String = "Until"
    override val from: String = "From"
    override val loyaltyCards: String = "Loyalty Cards"
    override val calculate: String = "Calculate"
    override val end: String = "End"
    override val start: String = "Start"
    override val period: String = "Period"
    override val January: String = "January"
    override val February: String = "February"
    override val March: String = "March"
    override val April: String = "April"
    override val May: String = "May"
    override val June: String = "June"
    override val July: String = "July"
    override val August: String = "August"
    override val September: String = "September"
    override val October: String = "October"
    override val November: String = "November"
    override val December: String = "December"
    override val fourQuarters: String = "Q4"
    override val threeQuarters: String = "Q3"
    override val twoQuarters: String = "Q2"
    override val oneQuarter: String = "Q1"
    override val twoHalfAYear: String = "2ST HALF"
    override val oneHalfAYear: String = "1ST HALF"
    override val next: String = "Next"
    override val previous: String = "Previous"
    override val previousWeek: String = "Previous Week"
    override val thisWeek: String = "This Week"
    override val yesterday: String = "Yesterday"
    override val today: String = "Today"
    override val rfid: String = "RFID"
    override val barcode: String = "BarCode"
    override val collectPointsWhenCharged: String = "Collect points only when charged"
    override val cardCanOnlyBeChargedByCash: String = "Card can only be topped up with cash"
    override val grantDiscountOnNetItems: String = "Also grant a discount on net items"
    override val grantDiscountWhenCharged: String = "Grant discount only when charged"
    override val discountNumber: String = "Discount No."
    override val discountGLWithPercent: String = "Rabatt GL, %"
    override val discountWithPercent: String = "Discount, %"
    override val debitCard: String = "Debit Card"
    override val cardType: String = "Card Type"
    override val art: String = "Art"
    override val owner: String = "Owner"
    override val email: String = "Email"
    override val telephone: String = "Telephone"
    override val firstName: String = "First Name"
    override val address: String = "Address"
    override val zipCity: String = "Zip"
    override val cardLimit: String = "Card limit"
    override val dailyLimit: String = "Daily limit"
    override val card: String = "Card"
    override val cardNumber: String = "Card number"
    override val lastUsed: String = "Last used"
    override val internetAccessCode: String = "Internet access code"
    override val series: String = "Series"
    override val customerCards: String = "Customer cards"
    override val points: String = "Points"
    override val ipAddress: String = "IP address"
    override val kitchenPrinterSerialNumber: String = "Kitchen printer serial number"
    override val addCakeDisplay: String = "Add cake display"
    override val serialNumber: String = "Serial number"
    override val logout: String = "Log out"
    override val backToAdmin: String = "Back to admin mode"
    override val myProfile: String = "My profile"
    override val globalSearch: String = "Global search"
    override val noItemToDisplay: String = "No items to display"
    override val standardInBracket: String = "<Standard>"
    override val mwstNormal: String = "MWST-Normal"
    override val salesVolume: String = "Sales"
    override val time: String = "Time"
    override val date: String = "Date"
    override val closingReports: String = "Closing Reports"
    override val standardWithoutPrinting: String = "Standard without printing"
    override val withCashReportAndCountProtocol: String = "With cash report and count protocol"
    override val withoutCash: String = "Without cash"
    override val standard: String = "Standard"
    override val withCashReport: String = "With cash report"
    override val vatRateSelection: String = "VAT Rate Selection"
    override val specialVat: String = "Special Vat"
    override val reducedVat: String = "Reduced Vat"
    override val normalVat: String = "Normal Vat"
    override val office: String = "Office"
    override val priceLevel: String = "Price Level"
    override val region: String = "Region"
    override val priceLevelInHouseButton: String = "Price Level In House Button"
    override val branch: String = "Branch"
    override val mode: String = "Mode"
    override val cashierName: String = "Cashier Name"
    override val copyForWaiter: String = "Copy for waiter"
    override val printer: String = "Printer"
    override val receiptCopy: String = "Receipt Copy"
    override val fromAmount: String = "From Amount"
    override val variable: String = "Variable"
    override val inTheHouse: String = "In-House"
    override val degree: String = "Degree"
    override val activateEmployeeCompletion: String = "Activate employee completion"
    override val degreeType: String = "Degree Type"
    override val close: String = "Close"
    override val previewForAppleWallet: String = "Preview for Apple Wallet"
    override val latestPurchasesAndMore: String = "Latest purchases and more"
    override val phone: String = "Phone"
    override val qrCode: String = "QR-Code"
    override val customerName: String = "Customer Name"
    override val customerNumber: String = "Customer Number"
    override val cardName: String = "Card Name"
    override val specialDiscountTier: String = "Special Discount Tier"
    override val discountTier: String = "Discount Tier"
    override val aboutTheCard: String = "More about the card is on the back!"
    override val cashAssistCard: String = "Cash Assist Card"
    override val balance: String = "Balance"
    override val customerCard: String = "Customer Card"
    override val previewForGoogleWallet: String = "Preview for Google Wallet"
    override val cardPreview: String = "Card preview"
    override val cardInfoPreview: String = "Card info preview"
    override val cashRegisterConfig: String = "Cash Register Config"
    override val menuCardImport: String = "Menu Card Import"
    override val advertisingText: String = "Advertising Text"
    override val optionalTwo: String = "Optional Two"
    override val optionalOne: String = "Optional One"
    override val vatNumber: String = "VAT Number"
    override val addition: String = "Addition"
    override val mfaCode: String = "MFA-Code"
    override val incomeExpanses: String = "Inc/Expanses"
    override val incomeExpanses1: String = "Inc/Expanses 1"
    override val incomeExpanses2: String = "Inc/Expanses 2"
    override val incomeExpanses3: String = "Inc/Expanses 3"
    override val incomeExpanses4: String = "Inc/Expanses 4"
    override val incomeExpanses5: String = "Inc/Expanses 5"
    override val name1: String = "Name 1"
    override val name2: String = "Name 2"
    override val name3: String = "Name 3"
    override val name4: String = "Name 4"
    override val name5: String = "Name 5"
    override val name6: String = "Name 6"
    override val name7: String = "Name 7"
    override val name8: String = "Name 8"
    override val name9: String = "Name 9"
    override val name10: String = "Name 10"
    override val creditCard: String = "Credit Card"
    override val cashFlow: String = "Cash Flow"
    override val companyLogo: String = "Company Logo"
    override val colorIsMissing: String = "Color is missing"
    override val titleFontColor: String = "Title font color"
    override val fontColor: String = "Font Color"
    override val preview: String = "Preview"
    override val wideCompanyLogo: String = "Wide company logo"
    override val heroImage: String = "Hero image"
    override val googleWallet: String = "Google Wallet"
    override val appleWallet: String = "Apple Wallet"
    override val website: String = "Website"
    override val titleWebsite: String = "Title Website"
    override val telephoneNumber: String = "Telephone Number"
    override val titleContact: String = "Title Contact"
    override val title2: String = "Title 2"
    override val titleField2: String = "Title Field 2"
    override val title1: String = "Title1"
    override val titleField1: String = "Title Field1"
    override val description: String = "Description"
    override val emailCompany: String = "Email Company"
    override val activeCustomersCard: String = "Mobile customer cards are active"
    override val virtualCard: String = "Virtual Card"
    override val addNewLocation: String = "Add new location"
    override val uploadFromPc: String = "Upload From Local"
    override val prompt: String = "Prompt"
    override val question: String = "Your Question"
    override val newImage: String = "New Image"
    override val newMenuCard: String = "New Menu Card"
    override val dataAssistant: String = "Data Assistant"
    override val price2: String = "Price 2"
    override val price1: String = "Price 1"
    override val numberDot: String = "No."
    override val addNewItem: String = "Add new item"
    override val variant1: String = "Variant 1"
    override val variant2: String = "Variant 2"
    override val variant3: String = "Variant 3"
    override val variant4: String = "Variant 4"
    override val variant5: String = "Variant 5"
    override val variant6: String = "Variant 6"
    override val variant7: String = "Variant 7"
    override val variant8: String = "Variant 8"
    override val variant9: String = "Variant 9"
    override val variant10: String = "Variant 10"
    override val kitchenInformation: String = "Kitchen Information"
    override val items: String = "Items"
    override val addNewSaleGroup: String = "Add new sale group"
    override val submit: String = "Submit"
    override val inactiveItems: String = "Inactive Items"
    override val activeItems: String = "Active Items"
    override val allItems: String = "All Items"
    override val individualFilter: String = "Individual Filter"
    override val creatingNewProduct: String = "Creating new product"
    override val numberOrNameIsWrong: String = "Number or Name is wrong."
    override val products: String = "Products"
    override val companyProfile: String = "Company Profile"
    override val imageAiDialogWaitingMsg: String = "Process may take more than 30 s"
    override val menuCardAIDialogWaitingMsg: String = "Process may take more than 3 m"
    override val generate: String = "Generate"
    override val hint: String = "Hint"
    override val allDays: String = "All Days"
    override val mondayFull: String = "Monday"
    override val tuesdayFull: String = "Tuesday"
    override val wednesdayFull: String = "Wednesday"
    override val thursdayFull: String = "Thursday"
    override val fridayFull: String = "Friday"
    override val saturdayFull: String = "Saturday"
    override val sundayFull: String = "Sunday"
    override val selectDays: String = "Select Days"
    override val color: String = "Color"
    override val changesValidFrom: String = "Changes Valid From"
    override val surchargePercent: String = "Surcharge %"
    override val away: String = "Away"
    override val surchargeAmount: String = "Surcharge Amount"
    override val priceLevels: String = "Price Levels"
    override val surchargeInHouse: String = "SurchargeInHouse"
    override val contain: String = "Contain"
    override val allergens: String = "Allergens"
    override val deliveryTimeInDays: String = "Delivery Days"
    override val minimumOrder: String = "Minimum Order"
    override val maximumOrder: String = "Maximum Order"
    override val vat: String = "VAT"
    override val printKitchenReceiptIfInfoSelected: String = "Print kitchen receipt only when kitchen information is selected"
    override val printKitchenReceiptIfInHouseActive: String = "Print kitchen receipt only when In-House button is activated"
    override val kitchen: String = "Kitchen"
    override val restaurant: String = "Restaurant"
    override val prices: String = "Prices"
    override val discount: String = "Discount"
    override val product: String = "Product"
    override val slash: String = "/"
    override val noDiscountPossible: String = "Customer net items (no discount possible)"
    override val employeeNetItems: String = "Employee net items"
    override val employeeConsumption: String = "Employee consumption"
    override val interimFinancialStatement: String = "Interim Financial Statement"
    override val enableUsersOnlyForTimeTracking: String = "Enable Users Only For Time Tracking"
    override val allReceipts: String = "All Receipts"
    override val noAuthorization: String = "No Authorization"
    override val onlyOwnReceipts: String = "Only Own Receipts"
    override val gastronomy: String = "Gastronomy"
    override val shortName: String = "Short Name"
    override val addNewUser: String = "Add new user"
    override val addNewCategory: String = "Add new category"
    override val img: String = "Image"
    override val menuCard: String = "Menu Card"
    override val remove: String = "Remove"
    override val confirm: String = "Confirm"
    override val cancel: String = "Cancel"
    override val printName: String = "Print Name"
    override val users: String = "Users"
    override val articleList: String = "Article List"
    override val operation: String = "Operation"
    override val general: String = "General"
    override val userPhoto: String = "User Photo"
    override val title: String = "Title"
    override val filter: String = "Filter"
    override val fibuNormal: String = "Fibu Normal"
    override val financialReduced: String = "Reduced"
    override val accounting: String = "Accounting"
    override val accountingPercent: String = "Accounting 0%"
    override val article: String = "Article"
    override val template: String = "Template"
    override val options: String = "Options"
    override val salesGroups: String = "Sales Groups"
    override val clickAndCollect: String = "Click&Collect"
    override val update: String = "Update"
    override val DAYS_END: String = "Day's End"
    override val ADMINISTRATOR: String = "Administrator"
    override val MANAGER: String = "Manager (Manager can access other users)"
    override val NO_SALES_TRIGGER: String = "No Sales Trigger (Maison)"
    override val cancellationRight: String = "Cancellation Rights"
    override val receiptName: String = "Receipt Name"
    override val password: String = "Password"
    override val name: String = "Name"
    override val availableEveryWhere: String = "Available Everywhere"
    override val waitersCastle: String = "Waiter's Castle"
    override val right: String = "Right"
    override val devices: String = "Devices"
    override val user: String = "User"
    override val search: String = "Search"
    override val number: String = "Number"
    override val language: String = "Language"
    override val street: String = "Street"
    override val label: String = "Label"
    override val companyName: String = "Company Name"
    override val zip: String = "Zip"
    override val city: String = "City"
    override val APP_NAME_PART1: String = "RunMy"
    override val APP_NAME_PART2: String = "Setup"
    override val saturday: String = "Sa"
    override val sunday: String = "Su"
    override val monday: String = "Mo"
    override val tuesday: String = "Tu"
    override val wednesday: String = "We"
    override val thursday: String = "Th"
    override val friday: String = "Fr"
    override val USER_NAME: String = "Jens Lehman"
    override val COMPANY_NAME: String = "HS-Soft AG"
    override val forgetYourPassword: String = "Forgotten password?"
    override val login: String = "Log in"
    override val enterYourPassword: String = "Enter your password."
    override val enterYourEmail: String = "Enter email *"
    override val status: String = "Status"
    override val spent: String = "Spent"
    override val sec: String = "sec"
    override val steps: String = "Steps"
    override val step: String = "Step"
    override val model: String = "Model"
    override val tokens: String = "Tokens"
    override val expertMode: String = "Expert mode"
    override val arguments: String = "Arguments"
    override val typeOrUseVoice: String = "Start typing or use your voice"
    override val availableToDownloadUntil: String = "Available to download until"
    override val dataAssistantWelcomeMessage: String = "Hello! How can I help you?"
    override val kuchen: String = "Kitchen"
    override val buffet: String = "Buffet"
    override val downloadExpired: String = "Download expired"
    override val receiptPrinterSettings: String = "Receipt printer"
    override val printerType: String = "Printer type"
    override val printerConnectionTarget: String = "Serial number / IP Address"
    override val kitchenSettings: String = "Kitchen settings"
    override val rooms: String = "Rooms"
    override val companyNameEmptyHint: String = "A blank Company Name can cause errors throughout your site"
    override val separateKitchenReport: String = "Separate kitchen report"
    override val kitchenStationAnnounce: String = "Announce"
    override val snOfKds: String = "KDS serial number"
    override val forgetPassInfo: String = "Verification code to reset password will be send to this email."
    override val floors = "Floors"
    override val forgetPassInfo2: String = "Enter verification code that was sent to your email and set your new password."
    override val sendCode: String = "Send code"
    override val verificationCode: String = "Verification code*"
    override val newPassword: String = "New password*"
    override val confirmPassword: String = "Confirm password*"
    override val enterNewPassword: String = "Enter new password"
    override val enterNewPasswordAgain: String = "Enter new password again"
    override val updatePassword: String = "Update password"
    override val passwordRequirements: String = "Password requirements"
    override val passwordReqLength: String = "At least 8 characters long"
    override val passwordReqLower: String = "At least one lowercase letter"
    override val passwordReqUpper: String = "At least one uppercase letter"
    override val passwordReqNumber: String = "At least one number"
    override val passwordReqSpecial: String = "At least one special character"

    override val enterProductNumber: String = "Enter product number"
    override val enterProductName: String = "Enter product name"
    override val enterMediaNumber: String = "Enter media number"
    override val enterMediaName: String = "Enter media name"
    override val enterSaleGroupName: String = "Enter sale group name"
    override val enterSaleGroupNumber: String = "Enter sale group number"
    override val enterCategoryName: String = "Enter category name"
    override val enterCategoryNumber: String = "Enter category number"
    override val enterUserName: String = "Enter user name"
    override val enterUserNumber: String = "Enter user number"
    override val enterLocationName: String = "Enter location name"
    override val enterLocationNumber: String = "Enter location number"
    override val printEFTReceipt: String = "Print EFT receipt"
    override val takeOver: String = "Take Over"
    override val addNewAlergene: String = "Add new allergen"
    override val createCustomeAlergene: String = "Create custom allergen"
    override val keyword: String = "Keyword"
    override val unit: String = "Unit"
    override val nutritionalValues: String = "Nutritional Values"
    override val type = "Type"
    override val startDate = "Start Date"
    override val endDate = "End Date"
    override val startTime = "Start Time"
    override val lambda_seconds = "Lambda Usage Seconds"
    override val data_size_kbytes = "Data Size KB"
    override val is_premium = "Is Premium"
    override val file_count = "File Count"
    override val freeCredits = "Free credits"
    override val premiumCredits = "Premium credits"
    override val freeCreditsInfo = "Used for basic questions and operations. These credits renew monthly and cannot be purchased."
    override val premiumCreditsInfo = "Used for advanced analytics and Al features. Purchase more as needed. These credits do not expire."
    override val creditsWarning = "are running low"
    override val learnMore = "Learn more"
    override val topUpCredits = "Top up credits"
    override val info = "Info"
    override val favorites = "Favorites"
}